export function mergeCustomerWithMember(
  customer: MarketingCustomer | null,
  member: MarketingMember | null
): MarketingCustomer | null {
  if (!customer && !member) return null;
  if (!customer) return member as unknown as MarketingCustomer;
  if (!member) return customer as MarketingCustomer;

  return {
    ...customer,
    member: {
      ...customer.member,
      ...member
    }
  } as MarketingCustomer;
}
